import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { Table } from 'core';
import NoResults from '../no-results';
import Row from './row';
import useStyles from './global-results.styles';

/**
 * The header search bar's dropdown. Unlike the Search page — which puts each index behind its own
 * tab — this is one list drawn from two indexes, so every row states whether it is a Member or an
 * Offer and links to the page for that kind of thing (#35516).
 *
 * Deliberately unpaginated: it is a quick-jump list under the toolbar, not a results table. Depth
 * belongs on the Search page.
 */
const GlobalResults = ({ loading, hits, onRowClick, error }) => {
  const classes = useStyles();

  return (
    <Paper square elevation={0} className={classes.resultsContainer}>
      {Boolean(loading || hits.length) && (
        <Table
          selfContained={false}
          loading={loading}
          paginationEnabled={false}
          body={hits.map((hit) => <Row key={hit.key} hit={hit} onClick={onRowClick} />)}
        />
      )}
      {Boolean(!loading && hits.length === 0) && <NoResults error={error} />}
    </Paper>
  );
};

GlobalResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  hits: PropTypes.array,
  onRowClick: PropTypes.func,
  error: PropTypes.object
};

GlobalResults.defaultProps = {
  hits: [],
  onRowClick: null,
  error: null
};

export default memo(GlobalResults);
